export interface ReplaceSimCache {
  OrderSim: any
}
export interface QrCodeCache {
  iccid: string
}

export interface AuthenticationStepUpCache {
  expirationTime?: Date
  context: "ReplaceSim" | "ShowQrCode" | "OrderNewSim"
  replaceSim?: ReplaceSimCache
  qrCode?: QrCodeCache
}

export const useAuthenticationStepUpCache = () => {
  const AuthenticationCacheKey = "StepUpAuthenticating"

  const tryJson = <T extends any>(v: any, defaultValue?: T) => {
    if (!v) {
      return defaultValue
    }
    try {
      return JSON.parse(v) as T
    } catch {
      return defaultValue
    }
  }

  function pushItem(
    authCache: AuthenticationStepUpCache,
    expirationTime?: Date
  ) {
    // 10 minutes
    const defaultExpiration = new Date(Date.now() + 10 * 60 * 1000)
    authCache = {
      ...authCache,
      expirationTime: expirationTime ?? defaultExpiration,
    }

    const cacheString = JSON.stringify(authCache)
    localStorage.setItem(AuthenticationCacheKey, cacheString)
  }

  function getItem() {
    const cacheString = localStorage.getItem(AuthenticationCacheKey)
    const item = tryJson<AuthenticationStepUpCache>(cacheString) || undefined
    return item
  }

  function clear() {
    localStorage.removeItem(AuthenticationCacheKey)
  }

  const cachedItem: AuthenticationStepUpCache | undefined = getItem()
  const isCacheActive = cachedItem?.expirationTime
    ? new Date() < new Date(cachedItem.expirationTime)
    : false

  return {
    pushItem,
    getItem,
    clear,
    isCacheActive,
    cachedItem,
  }
}

export default useAuthenticationStepUpCache
